<script setup lang="ts">
import { useSystemAlertStore } from '@/app/system-alert/stores/useSystemAlertStore'
import { storeToRefs } from 'pinia'
import { computed, ref, watch } from 'vue'

const store = useSystemAlertStore()
const { errors } = storeToRefs(store)

const alert = ref<boolean>(false)
const lastError = computed(() => errors.value?.slice(-1)[0] ?? null )

watch(lastError,() => {
    if (!lastError.value) return

    alert.value = true
    setTimeout(() => alert.value = false, 3000)
})

</script>

<template>
    <div class="notificationContainer">
        <transition name="slide-y-transition">
            <v-alert
                v-model="alert"
                :text="lastError?.message"
                :type="lastError?.type ?? 'info'"

            ></v-alert>
        </transition>
    </div>
</template>
<style>
.notificationContainer {
    position: fixed;
    top: 10px;
    right: 10px;
    display: grid;
    grid-gap: .5em;
    z-index: 999999;
}


</style>
